export class Ocupaciones{
    public id_ocupacion_pk:Number;
    public ocupacion:String;
    constructor(){
        //this is intentional
    }
}